import { TrustShell } from './components/TrustShell';
import { TRUST_ASSURANCE_ITEMS, TRUST_CENTER_EYEBROW } from './trustCopy';
import { TrustKeyTerms } from './trustKeyTerms';
import { getTrustBaseUrl, getWebsiteUrl } from './config';

export function TrustLandingPage() {
  const websiteUrl = getWebsiteUrl();

  return (
    <TrustShell>
      <section className="trust-hero relative overflow-hidden border-b border-white/10">
        <div className="trust-hero-glow pointer-events-none absolute inset-0" aria-hidden />
        <div className="trust-hero-grid pointer-events-none absolute inset-0 opacity-40" aria-hidden />

        <div className="relative mx-auto max-w-5xl px-5 sm:px-6 lg:px-8 pt-10 pb-10 text-center lg:pt-12 lg:pb-12">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.2em] text-primary">
            {TRUST_CENTER_EYEBROW}
          </p>
          <h1 className="font-display text-4xl font-bold tracking-tight md:text-6xl">
            Show what your AI
            <span className="block text-white">was stopped from doing</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-gray-300 md:text-xl">
            <TrustKeyTerms>
              A public AI Trust Center for your product: how many requests were checked and which laws
              a rule caught something under, generated by ComplyEdge from live decisions.
              Not a PDF upload or self-reported questionnaire.
            </TrustKeyTerms>
          </p>
          <p className="mx-auto mt-4 max-w-xl font-mono text-sm text-gray-500">
            {getTrustBaseUrl().replace(/^https?:\/\//, '')}/your-slug
          </p>
        </div>
      </section>

      <div className="mx-auto max-w-5xl px-5 sm:px-6 lg:px-8 pt-10 pb-20 lg:pt-12 lg:pb-24">
        <ul className="grid gap-4 md:grid-cols-3">
          {TRUST_ASSURANCE_ITEMS.map((item) => (
            <li
              key={item.title}
              className="trust-metric-card trust-card rounded-2xl border border-white/10 bg-white/[0.04] p-5 text-left"
            >
              <h2 className="font-display text-base font-semibold text-light">
                {item.title}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-gray-400">
                <TrustKeyTerms>{item.description}</TrustKeyTerms>
              </p>
            </li>
          ))}
        </ul>
        <p className="mt-12 text-center text-sm text-gray-400">
          <a
            href={websiteUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            <strong className="font-bold">ComplyEdge</strong>: block what breaks a rule, log every check
          </a>
          {' · '}
          <a
            href={`${websiteUrl}/docs/trust-badge.html`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary hover:underline"
          >
            Publish your AI Trust Center
          </a>
        </p>
      </div>
    </TrustShell>
  );
}
